import CMSWrapper from '@/features/shared/CMSWrapper';
import ContentContainer from '@/features/shared/ContentContainer';
import { MuiContainer } from '@/features/shared/material-ui';
import { resolveColorName, resolveRTC, resolveSpacingSize, resolveTheme } from '@/utils/resolvers';
import React, { useMemo, useRef } from 'react';
import DynamicStats from './DynamicStats';

const resolveColumnCompound = ({ rawVal = [] }: any) => {
  const stats = rawVal.map(({ dynamicStat: columns }: any) => {
    const [column] = columns;
    const { dynamicStat, description } = column;
    return { value: dynamicStat, description: resolveRTC({ rawVal: description }) };
  });

  return stats;
};

const MappedDynamicStats = ({ content, presentation, contentButtons }: any) => {
  const { topSpacing, bottomSpacing, containerBackgroundColor, containerInsetWidth, ...props } =
    presentation;
  const containerProps = useMemo(
    () => ({
      topSpacing,
      bottomSpacing,
      topBackgroundColor: containerBackgroundColor,
      bottomBackgroundColor: containerBackgroundColor,
    }),
    [bottomSpacing, containerBackgroundColor, topSpacing],
  );
  const theme = useMemo(
    () => resolveTheme('bg-color')({ rawVal: containerBackgroundColor }),
    [containerBackgroundColor],
  );

  const { dynamicStat } = content;

  return (
    <ContentContainer {...containerProps} datalayerPosition="dynamic_stats">
      <MuiContainer className={containerInsetWidth}>
        <DynamicStats theme={theme} {...dynamicStat} contentButtons={contentButtons} {...props} />
      </MuiContainer>
    </ContentContainer>
  );
};

const DynamicStatsCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        dynamicStat: [
          null,
          {
            groupTitleAndDescription: [null, resolveRTC],
            columnCompound: ['stats', resolveColumnCompound],
          },
        ],
      },
    ],
    componentParameterMap: [
      'presentation',
      {
        'bottom-spacing': ['bottomSpacing', resolveSpacingSize],
        'top-spacing': ['topSpacing', resolveSpacingSize],
        'container-background-color': ['containerBackgroundColor', resolveColorName],
        'container-inset-width': 'containerInsetWidth',
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={MappedDynamicStats}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default DynamicStatsCMSWrapper;
